export class CostumArray
{
  value!: string;
  display!: string;
}
